import type { WorkspaceUpdateWorkspaceMemberRoleRequest } from '@/model/workspace/api.generated';
import type { WorkspaceResponse } from '@/model/workspace/dto.generated';

export type MemberRole = WorkspaceUpdateWorkspaceMemberRoleRequest['role'];

export const MEMBER_ROLES: MemberRole[] = ['owner', 'admin', 'member', 'readonly'];

export const isMemberRole = (value: unknown): value is MemberRole =>
  typeof value === 'string' && MEMBER_ROLES.includes(value as MemberRole);

const isAlephApiError = (err: unknown): err is { data?: { error?: { code?: string } } } =>
  typeof err === 'object' && err !== null && 'data' in err;

export const isSeatNotIncludedError = (err: unknown): boolean =>
  isAlephApiError(err) && err.data?.error?.code === 'SEAT_NOT_INCLUDED';

const WORKSPACE_ROLES = ['readonly', 'member', 'admin', 'owner'] as const;

export type WorkspaceRole = (typeof WORKSPACE_ROLES)[number];

export const toWorkspaceRole = (role: string | undefined): WorkspaceRole | null =>
  WORKSPACE_ROLES.find((known) => known === role) ?? null;

export const parseName = (name: string, workspaces: WorkspaceResponse[]): string => {
  let counter = 0;
  let newName = name;
  while (workspaces.some((workspace) => workspace.name === newName)) {
    counter += 1;
    newName = `${name}-${counter}`;
  }
  return newName;
};
